import React, { useEffect, useState } from 'react'
import { apiRunWithAxios } from './APIRunWithAxios';
import { useDispatch, useSelector } from 'react-redux';
import DateService from '../../../../services/DateService'
import { eventTypes } from './EventTypes';
import TapSelect from '../../../../components/ui/TapSelect';
import { authLoginAndGetJWTToken } from '../../../../store/actions/OmniComm/OmniCommAuthAction';
import TapHelper from '../../../../services/TapHelper';
import Loader from '../../../../components/ui/Loader/Loader';
import { toast } from 'react-toastify';
import swal from 'sweetalert';

function EventsReport({formData}) {

    const dispatch                  =   useDispatch();
    const { data }                  =   useSelector(state => state.omniAuthLoginReducer);    

    const asset                     =   formData.asset;

    const[loading, setLoading]      =   useState(false);
    const[eventData, setEventData]  =   useState([]);
    const[selectedEvent, setSelectedEvent]  =   useState('')

    useEffect(() => {
        if (data?.jwt) {
            getEventsData()
        }
    }, [formData, data, selectedEvent])
    
    const getEventsData          =   async () => {
        
        const timeBegin     =   Math.floor(new Date(formData.date_range_start + " 00:00:00").getTime() / 1000);
        const timeEnd       =   Math.floor(new Date(formData.date_range_end + " 23:59:59").getTime() / 1000);
        setEventData([]);
        if(formData.asset_id && timeBegin && timeEnd) {
            setLoading(pre => !pre);
            try {
                let params          =   {
                    timeBegin,
                    timeEnd,
                }
                if(selectedEvent) {
                    params          =   {...params, type : selectedEvent}
                }
                let response        =   await apiRunWithAxios(`https://online.omnicomm.in/ls/api/v1/reports/events/${formData.asset_id}`, "GET",  data?.jwt, params);
                const results       =   response.data;
                const events        =   results?.events ? results.events.filter(d => [1,2,3,4,5,6,7,8].includes(d.type)).reverse() : []
                setEventData(events);
                setLoading(false);
            } catch (error) {
                setLoading(false);
                if(error?.response?.status === 401 && error?.response?.data?.error === "Unauthorized") {
                    swal({
                        title: "Refresh",
                        text: "Please refresh again for fetch events data.",
                        icon: "warning",
                        // dangerMode: true,
                        buttons: ["Cancel", "Refresh"],
                    }).then(willDelete => {
                        if (willDelete) {
                            dispatch(authLoginAndGetJWTToken());
                        }
                    });
                }
            }finally{
                setLoading(false);
            }
        }else {
            if(!formData.uuid) {
                toast.error('The asset information you provided is incorrect.', { position: toast.POSITION.TOP_RIGHT });
            }else {
                toast.error('Time period is required, for event data', { position: toast.POSITION.TOP_RIGHT });
            }
        }

        
    }

    return (
        <>
            <div className="row mb-2" style={{ zIndex: 3, position: "relative" }}>
                <label className="col-sm-3 col-form-label text-end">Events</label>
                <div className="col-sm-6">
                    <TapSelect
                        options={eventTypes}
                        value={eventTypes.filter(s => s.value == selectedEvent)}
                        changeEvent={(opt) => {
                            if(opt) {
                                setSelectedEvent(opt.value)
                            }else {
                                setSelectedEvent(null)
                            }
                        }}
                        isSearchable={true}
                        isClearable={true}
                        placeholder="Select Event"
                    />
                </div>
            </div>
            <table className="table table-hover table-bordered mt-1 table-fixed" style={{ zIndex: 2, position: "relative" }}>
                <thead className="table-secondary">
                    <tr>
                        <th className='text-center' style={{ width: "5%" }}>#</th>
                        <th style={{ width: "25%" }}>Asset</th>
                        <th style={{ width: "25%" }}>Date & time</th>
                        <th style={{ width: "20%" }}>Event</th>
                        <th style={{ width: "205" }}>Parameters</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        loading 
                        ?
                        <tr className='text-center'><td colSpan={5}><Loader/></td></tr>
                        :
                        eventData && eventData.length > 0 
                        ?
                        eventData.map((d, i) => {
                            let event = eventTypes.find(e => e.value == d.type)
                            let parameters = null
                            if(d.parameters) {
                                if([1,2,3,4].includes(d.type)) {
                                    parameters = TapHelper.numberFormatter(d.parameters[1])
                                } else if([5].includes(d.type)) {
                                    parameters = DateService.formatSecondsToTime(d.parameters[0])
                                } 
                            }
                            return <tr>
                                <td className='text-center'>{i+1}</td>
                                <td className="fs14 fw-normal" >{asset?.name}</td>
                                <td className=''>{DateService.SecToDateTimeFormat(d.timestamp)}</td>
                                <td className=''>{event?.label}</td>
                                <td className=''>{event?.parameters} {parameters}</td>
                            </tr>
                        })
                        :
                        <tr className='text-center'><td colSpan={5}>No Record Found</td></tr>
                    }
                </tbody>
            </table>
        </>

    )
}

export default EventsReport